import { useState } from "react";

import { Button, Input } from "antd";
import styled from "styled-components";

import { UserArpsItem } from "models/UserArpsModel";

import { useAddCommentMutation } from "./useAddCommentMutation";

interface TypeWellCommentFieldProps {
  selectedTypeWell: UserArpsItem;
}

function TypeWellCommentField({ selectedTypeWell }: TypeWellCommentFieldProps) {
  const [commentInput, setCommentInput] = useState("");

  const [addComment] = useAddCommentMutation({
    commentInput,
    selectedTypeWellId: selectedTypeWell?.id,
    onCompleted: () => {
      setCommentInput("");
    }
  });

  return (
    <FieldContainer>
      <Input.TextArea
        placeholder="Add a comment"
        autoSize={{ minRows: 1, maxRows: 6 }}
        value={commentInput}
        onChange={(e) => setCommentInput(e.target.value)}
      />
      {!!commentInput && (
        <CommentButtonContainer>
          <SubmitButton onClick={addComment} visible={!!commentInput}>
            Submit
          </SubmitButton>
          <CancelButton onClick={() => setCommentInput("")} visible={!!commentInput}>
            Cancel
          </CancelButton>
        </CommentButtonContainer>
      )}
    </FieldContainer>
  );
}

export default TypeWellCommentField;

const FieldContainer = styled.div`
  display: block;
  padding: 15px 15px 0px;
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  gap: 5px;

  .ant-input {
    flex: 2 1;
    min-width: 250px;
    border-radius: var(--border-radius);

    &:hover {
      border-color: var(--color-primary);
    }

    &.ant-input-focused,
    &:focus {
      border-color: var(--color-primary-hover);
      box-shadow: 0 0 0 2px rgba(var(--color-primary-rgb), 0.3);
    }
  }
`;

const CommentButtonContainer = styled.div`
  display: flex;
  gap: 5px;
  flex: 1;
`;

const SubmitButton = styled(Button)`
  background-color: var(--color-primary);
  color: white;
  flex: 1;

  &:focus {
    background-color: var(--ant-primary-color);
    color: white;
  }
  &:hover {
    background-color: white;
    color: black;
  }
`;

const CancelButton = styled(Button)`
  flex: 1;
`;
